import axios from 'axios';

// Build-time: set VITE_API_URL from backend stack ApiUrl when deploying. Fallback for local dev only.
const BUILD_API_URL =
  import.meta.env.VITE_API_URL ||
  'http://localhost:3001';

// When opened on the test frontend host, use test API (set at build time for test deploys)
const TEST_FRONTEND_HOST = (import.meta.env.VITE_TEST_FRONTEND_HOST || '').trim();
const TEST_API_URL = (import.meta.env.VITE_API_URL_TEST || '').trim();
const isTestFrontend = TEST_FRONTEND_HOST && TEST_API_URL && window.location.hostname === TEST_FRONTEND_HOST;
const API_URL = isTestFrontend ? TEST_API_URL : BUILD_API_URL;

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Ensure token is sent on every request (avoids 401 on large bodies where defaults can be dropped)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // Login/register can return 401 for wrong credentials — not a session expiry; do not wipe state or hard-redirect
      const isCredentialCheck =
        url.includes('/auth/login') || url.includes('/auth/register');
      if (isCredentialCheck) {
        return Promise.reject(error);
      }
      if (!url.includes('check_contract_criteria_status')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

